import styles from './SegmentedToggle.module.css';

interface Props<T extends string> {
  options: readonly { value: T; label: string }[];
  value: T;
  onChange(value: T): void;
}

export function SegmentedToggle<T extends string>({ options, value, onChange }: Props<T>) {
  return (
    <div className={styles.wrap}>
      {options.map((opt) => (
        <button
          key={opt.value}
          className={`${styles.opt} ${opt.value === value ? styles.selected : ''}`}
          onClick={() => onChange(opt.value)}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
